<template>
  <el-dialog
    title="修改记录"
    width="740px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-table v-loading="loading" :data="list" style="width:100%" border>
      <el-table-column label="操作人" width="120" align="center">
        <template v-slot="{ row }">
          <span>{{ row.insertByName || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" width="158" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.insertDate || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="修改内容" min-width="200" align="center">
        <template slot-scope="{ row }">
          <span class="wrap-text">{{ row.content || '--' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination
      @size-change="handlePageSize"
      @current-change="handlePage"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total"
    >
    </el-pagination>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { gettalentPoolRecordListPage } from "@/api/product/base"

export default {
  name: 'Record',

  data () {
    return {
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0
      },
      dialogVisible: false,
      loading: false,
      list: []
    }
  },
  methods: {
    init (id) {
      this.pageInfo.id = id
      this.getListPage()
      this.dialogVisible = true
    },
    getListPage() {
      this.loading = true
      gettalentPoolRecordListPage(this.pageInfo).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.pageInfo.total = parseInt(data.total)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose () {
      this.pageInfo = this.$options.data().pageInfo
      this.list = []
      this.dialogVisible = false
    },
    handlePage(current) {
      this.pageInfo.page = current
      this.getListPage()
    },
    handlePageSize(size) {
      this.pageInfo.limit = size
      this.getListPage()
    },
  }
}
</script>

<style lang="scss" scoped>
.wrap-text {
  display: inline-block;
  white-space: pre-wrap;
  text-align: left;
}
</style>
